const IconsList = ({ title, list }) => {
  const normalizedData = {
    title,
    list,
  };

  return normalizedData;
};

export default IconsList;
